module.exports = __webpack_public_path__ + "img/logout.a93f63d6.svg";